import React from 'react';
import { Modal } from 'antd';
import { RocketFilled, InfoCircleFilled } from '@ant-design/icons';
import { Flex, Box, Button, Text } from 'atoms';
import { markModalAvailable } from './webBlockNotice';

markModalAvailable();

const PLAY_STORE_URL =
	'https://play.google.com/store/apps/details?id=com.ripplr.dms&pcampaignid=web_share';

export default function DownloadAppModal() {
	const onDownload = () => {
		window.location.href = PLAY_STORE_URL;
	};

	return (
		<Modal
			width={360}
			footer={null}
			visible
			closable={false}
			maskClosable={false}
			keyboard={false}
			centered
			bodyStyle={{ padding: 0, borderRadius: 12 }}
			style={{ borderRadius: 12, overflow: 'hidden' }}
		>
			<Box p="20px">
				<Flex alignItems="center" mb="16px">
					<Flex
						alignItems="center"
						justifyContent="center"
						width="40px"
						height="40px"
						mr="12px"
						style={{
							backgroundColor: '#E6F0FF',
							borderRadius: 10,
						}}
					>
						<RocketFilled style={{ color: '#1677FF', fontSize: 20 }} />
					</Flex>
					<Text fontSize="18px" fontWeight="700" color="#1F2937">
						Important Update
					</Text>
				</Flex>

				<Box
					style={{
						borderTop: '1px solid #E5E7EB',
						marginLeft: '-20px',
						marginRight: '-20px',
					}}
				/>

				<Text mt="16px" mb="8px" fontSize="16px" fontWeight="700" color="#1677FF">
					Install the New Android App to Continue
				</Text>

				<Text fontSize="14px" color="#6B7280" lineHeight="1.5" mb="16px">
					To continue using the service, you must switch to the Android app.{' '}
					<Text as="span" fontWeight="700" color="#374151">
						Click Below to Download
					</Text>
				</Text>

				<Flex
					alignItems="flex-start"
					p="12px"
					mb="20px"
					style={{
						backgroundColor: '#FFF7ED',
						border: '1px solid #FDBA74',
						borderRadius: 8,
					}}
				>
					<InfoCircleFilled style={{ color: '#F97316', fontSize: 16, marginTop: 2 }} />
					<Text ml="10px" fontSize="13px" color="#9A3412" lineHeight="1.5">
						The web app is no longer supported and will be discontinued shortly.
					</Text>
				</Flex>

				<Button
					variant="primary"
					block
					onClick={onDownload}
					style={{
						height: 48,
						borderRadius: 8,
						backgroundColor: '#1677FF',
						borderColor: '#1677FF',
						fontWeight: 600,
						fontSize: 15,
					}}
				>
					Download Now
				</Button>
			</Box>
		</Modal>
	);
}
